export enum Types {
	DADOS_AGENDAMENTO_REQUEST = '@atendimento/DADOS_AGENDAMENTO_REQUEST',
	DADOS_AGENDAMENTO_CLEAR = '@atendimento/DADOS_AGENDAMENTO_CLEAR',
}

export interface DadosAgendamentoState {
	numeroProtocolo: string;
	senhaAtendimento: string;
}
